
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabinsolapur() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Solapur',
        heading: 'etravo : Corporate Cab and Bus Services in Solapur',
        headingDescription: 'eTravo provides dependable Corporate Cab and Bus Services in Solapur, designed to support the transportation needs of businesses, industries, and corporate offices. From executive cabs for client visits and airport transfers to large-capacity buses for employee transportation and corporate events, we offer reliable, timely, and professional travel solutions. Our fleet features GPS-enabled tracking, comfortable seating, and experienced chauffeurs, ensuring a safe and seamless mobility experience. Choose eTravo in Solapur for smart and scalable corporate transport services.',

        top: 'Top Places to Visit in Solapur with etravo',
     "topPlaces": [
    {
      "title": "Shri Siddheshwar Temple",
      "description": "Located in the heart of Solapur, this temple is dedicated to Lord Siddheshwar, a revered saint and devotee of Lord Shiva. Surrounded by a serene lake, it's a significant pilgrimage site, especially during the annual Makar Sankranti fair."
    },
    {
      "title": "Bhuikot Fort",
      "description": "Also known as Solapur Fort, this 14th-century fort was built by the Bahmani dynasty. It features double fortification, ancient temples, and a mosque, reflecting a blend of architectural styles."
    },
    {
      "title": "Great Indian Bustard Sanctuary",
      "description": "Situated in Nannaj, this sanctuary is dedicated to the conservation of the critically endangered Great Indian Bustard. It's a haven for bird watchers and nature enthusiasts."
    },
    {
      "title": "Akkalkot Swami Samarth Maharaj Temple",
      "description": "Located in Akkalkot, about 40 km from Solapur, this temple is dedicated to Swami Samarth Maharaj, a 19th-century saint. Devotees visit to seek blessings and experience spiritual tranquility."
    },
    {
      "title": "Tulja Bhavani Temple",
      "description": "Situated in Tuljapur, approximately 45 km from Solapur, this temple is one of the 51 Shakti Peethas and is dedicated to Goddess Bhavani, a form of Durga. It's a major pilgrimage center in Maharashtra."
    },
    {
      "title": "Bhagwant Temple, Barshi",
      "description": "Located in Barshi, this unique temple is dedicated to Lord Vishnu and is one of the few temples where Vishnu is worshipped as 'Bhagwant'. The temple showcases Hemadpanthi architectural style."
    },
    {
      "title": "Hazrat Shah Zahur Dargah",
      "description": "A revered Sufi shrine in Solapur, attracting devotees from various faiths. The dargah is known for its peaceful ambiance and annual Urs festival."
    },
    {
      "title": "Sambhaji Lake",
      "description": "A serene lake in Solapur city, ideal for leisurely walks and relaxation. The surrounding area is a popular spot for locals and visitors alike."
    },
    {
      "title": "Akluj Fort",
      "description": "Located in Akluj, this fort has historical significance and has been restored to depict scenes from Shivaji Maharaj's life. It's a blend of history and culture."
    },
    {
      "title": "Solapuri Chaddar Shopping",
      "description": "Solapur is renowned for its cotton blankets known as 'Solapuri Chaddars'. Shopping for these traditional textiles offers insight into the city's rich weaving heritage."
    }
  ],
   "services": [
    {
      "name": "Corporate Employee Transport in Solapur",
      "description": "eTravo offers efficient and reliable corporate employee transport services in Solapur, designed to meet the daily commute needs of businesses across various industries. Our transport solutions focus on timely pickups and drop-offs, ensuring your employees reach the office and return home comfortably and safely. With flexible route planning and customized schedules, we help companies improve workforce punctuality and productivity."
    },
    {
      "name": "Business Cab and Bus Rentals Solapur",
      "description": "For businesses in Solapur looking for flexible transport options, eTravo provides a range of cab and bus rentals. Whether you require small group cab services or large capacity buses for team transport, we offer competitive pricing, modern vehicles, and professional drivers to support your corporate travel needs, be it daily commutes, meetings, or offsite events."
    },
    {
      "name": "Staff Commute Bus Services in Solapur",
      "description": "eTravo’s staff commute bus services in Solapur offer dependable and cost-effective solutions for transporting your workforce to and from the workplace. Our buses are well-maintained, air-conditioned, and equipped with safety features, ensuring a comfortable journey for employees while helping companies reduce absenteeism and travel-related stress."
    },
    {
      "name": "Cab Hire for Corporate Executives in Solapur",
      "description": "Enhance your corporate travel experience with eTravo’s premium cab hire services for executives in Solapur. We provide luxury sedans and SUVs driven by experienced chauffeurs, ensuring timely and professional transportation for meetings, airport transfers, and business events. Our executive cabs come with amenities that guarantee comfort and privacy for busy professionals."
    },
    {
      "name": "Budget-Friendly Corporate Travel in Solapur",
      "description": "At eTravo, we understand the importance of cost-effective transportation solutions. Our budget-friendly corporate travel options in Solapur allow companies to provide reliable transport services without compromising on safety or quality. Choose from economical cab hires shuttles, and efficient bus routes tailored to your business needs."
    },
    {
      "name": "Luxury Bus Rentals for Business Events in Solapur",
      "description": "For corporate events, conferences, or team outings in Solapur, eTravo offers luxury bus rentals equipped with modern amenities and spacious seating. Our luxury buses ensure that your staff and guests travel in comfort and style, making a positive impression while providing a stress-free travel experience."
    }
  ],
  "tableData": [
    ["Corporate Employee Transport in Solapur", "Business Cab and Bus Rentals Solapur"],
    ["Staff Commute Bus Services in Solapur", "Cab Hire for Corporate Executives in Solapur"],
    ["Budget-Friendly Corporate Travel in Solapur", "Luxury Bus Rentals for Business Events in Solapur"]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Reliable Corporate Transport Solutions in Solapur",
        "WhyChoosedescription": "eTravo offers dedicated cab and bus services for businesses in Solapur, ensuring timely employee commutes, executive travel, and client pickups. Whether you're located in the textile hub, MIDC industrial zones, or academic institutions, we provide dependable transportation tailored to your corporate needs."
    },
    {
        "WhyChooseheading": "Fleet for Every Corporate Requirement",
        "WhyChoosedescription": "Our fleet in Solapur includes a range of vehicles—from air-conditioned sedans for executive travel to high-capacity buses for employee shuttles. Every vehicle is well-maintained, clean, and equipped with comfortable seating, making daily and long-distance rides smooth and professional."
    },
    {
        "WhyChooseheading": "Trained Drivers with Local Route Expertise",
        "WhyChoosedescription": "eTravo’s drivers are background-verified and experienced in navigating Solapur's city roads, industrial areas, and nearby towns. They are trained in corporate etiquette, ensuring a safe, respectful, and smooth experience for your employees, clients, and senior executives."
    },
    {
        "WhyChooseheading": "Shift-Friendly Transport for Industries and Institutions",
        "WhyChoosedescription": "With industries and colleges operating across various shifts, our transport schedules are designed to be flexible. eTravo provides round-the-clock cab and bus services in Solapur, supporting businesses with morning, evening, and overnight shifts efficiently and reliably."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Corporate Invoicing",
        "WhyChoosedescription": "We believe in clear, honest pricing. eTravo offers competitive rates with no hidden charges and GST-compliant invoicing for businesses in Solapur. Our flexible billing models are ideal for organizations that require recurring services or scalable transport packages."
    },
    {
        "WhyChooseheading": "Commitment to Safety and Hygiene",
        "WhyChoosedescription": "Your employees’ safety is our top priority. All vehicles are equipped with GPS, emergency kits, seat belts, and are sanitized regularly. We adhere to strict safety protocols and conduct routine vehicle inspections to maintain high standards of travel safety."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Live Ride Tracking",
        "WhyChoosedescription": "Our operations team works around the clock to ensure smooth coordination. Whether it’s a last-minute change, route adjustment, or emergency request, eTravo’s 24/7 support system keeps your transport operations on track at all times."
    },
    {
        "WhyChooseheading": "Customized Travel Solutions for Solapur Businesses",
        "WhyChoosedescription": "Every organization is different—and so are their transport needs. eTravo builds personalized travel solutions based on your company size, route preferences, shift patterns, and employee strength. From daily office transport to VIP movement and outstation trips, we handle it all."
    }
]































    }

// Corporate Cab and Bus Services in Solapur – eTravo

const faqData = [
    [
        {
            question: 'What services does eTravo offer for corporate transportation in Solapur?',
            answer: 'eTravo provides professional cab and bus services in Solapur tailored for corporate needs, including employee commutes, executive transport, intercity business travel, and event logistics.',
        },
        {
            question: 'Can eTravo manage daily transport for industrial and commercial sectors in Solapur?',
            answer: 'Yes, we offer shift-based employee transportation for factories, industrial parks, and corporate offices with scheduled pickups, optimized routing, and real-time fleet monitoring.',
        },
        {
            question: 'What types of vehicles are available for corporate clients in Solapur?',
            answer: 'Our fleet includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses (13–50 seaters), ensuring safety, comfort, and scalability for teams of all sizes.',
        },
        {
            question: 'Do the transport services include safety tracking and compliance reporting?',
            answer: 'Absolutely. All our vehicles are GPS-enabled, and we provide real-time tracking, driver background verification, route compliance reports, and dedicated safety protocols.',
        },
        {
            question: 'Can we hire eTravo for corporate events or client visits in and around Solapur?',
            answer: 'Yes, we offer flexible travel solutions for corporate events, client site visits, factory tours, and outstation meetings with full coordination and professional drivers.',
        },
        {
            question: 'Is dedicated account management available for businesses in Solapur?',
            answer: 'Yes, every corporate account is assigned a dedicated manager who oversees route planning, fleet coordination, issue resolution, and customized reporting.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rajendra Pawar',
        designation: 'Admin Manager, SolapurTech Components',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has greatly improved our employee transport service in Solapur. The vehicles are punctual, and the support team is always responsive and efficient.”',
    },
    {
        name: 'Ms. Anuja Shinde',
        designation: 'HR Officer, MagnaTextiles Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve had a reliable and professional experience with eTravo. Their cabs and buses are clean, well-managed, and perfect for corporate use in Solapur.”',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Solapur",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-solapur.jpg",
  "description": "Reliable corporate cab and bus services in Solapur by eTravo. Ideal for employee transport, business cab and bus rentals, staff commute, and corporate events with budget-friendly and luxury options.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1620"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2099",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-solapur"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Solapur | Employee Transport & Business Rentals | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Solapur with eTravo for employee transport, staff commute, and business events. Budget-friendly and luxury options available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabinsolapur;